export function isBottomEdge(node: HTMLElement, multiplier: number = 1, values?: { clientHeight: number }) {
  const rect = node.getBoundingClientRect()
  const height = values ? values.clientHeight : window.innerHeight
  return rect.top - height < height * multiplier
}

export function isTopEdge(values: { clientHeight: number; scrollTop: number }, multiplier: number = 1) {
  const height = values.clientHeight
  const top = values.scrollTop
  return top < height * multiplier
}
